import { Area } from "tht-impianti-cl";

export interface AreaSelectionState {
  areas: Area[];
  selectedAreaId: string | null; // null means "all" is selected
  loading: boolean;
}

export const initialAreaSelectionState: AreaSelectionState = {
  areas: [],
  selectedAreaId: null, // Default to "all"
  loading: false
}; 